export default __webpack_public_path__ + "static/media/ic-cancel-circle-red.9ca30db2.svg";